import { AppSettings } from "@/AppSettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle, Divider, IconButton, alertClasses, darken, lighten, styled } from "@mui/material";
import { grey } from "@mui/material/colors";
import MuiMarkdown from "mui-markdown";
import { FC } from "react";

const StyledAlert = styled(Alert)(({ theme }) => ({ 
    overflow: 'auto'
}));

const DefaultAlert = styled(Alert)(({ theme }) => {
 
    const getColor = theme.palette.mode === 'light' ? darken : lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? lighten : darken;
    const color = grey[900];


    return { 
        overflow: 'auto',
        marginBottom: theme.spacing(2),
        color: getColor(color, 0.6),
        backgroundColor: getBackgroundColor(color, 0.9),

        [`& .${alertClasses.icon}`]: {
            color: getColor(color, 0.6)
        }
    }
});

interface ISourceDataFormMessagesProps {
    alertSuccess?: string;
    alertInformation?: string;
    alertWarning?: string;
    alertError?: string;
    alertDefault?: string;
}

export const SourceDataFormMessages: FC<ISourceDataFormMessagesProps> = ({
    alertSuccess,
    alertInformation,
    alertWarning,
    alertError,
    alertDefault
}) => { 

    return (
        <>
            {
                alertSuccess && (
                    <StyledAlert
                        severity="success"
                        icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertSuccess} />}
                    >
                        <MuiMarkdown>{alertSuccess}</MuiMarkdown>
                    </StyledAlert>
                )
            }
            {
                alertInformation && (
                    <StyledAlert
                        severity="info"
                        icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertInformation} />}
                    >
                        <MuiMarkdown>{alertInformation}</MuiMarkdown>
                    </StyledAlert>
                )
            }
            {
                alertWarning && (
                    <StyledAlert
                        severity="warning"
                        icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertWarning} />}
                    >
                        <MuiMarkdown>{alertWarning}</MuiMarkdown>
                    </StyledAlert>
                )
            }
            {
                alertError && (
                    <StyledAlert
                        severity="error"
                        icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertError} />}
                    >
                        <MuiMarkdown>{alertError}</MuiMarkdown>
                    </StyledAlert>
                )
            }
            {
                alertDefault && (
                    <DefaultAlert
                        icon={<FontAwesomeIcon fixedWidth icon={AppSettings.icons.alertDefault} />}
                    >
                        <MuiMarkdown>{alertDefault}</MuiMarkdown>
                    </DefaultAlert>
                )
            }
            {
                (alertSuccess ||
                alertInformation ||
                alertWarning ||
                alertError ||
                alertDefault) && (
                    <Divider />
                )
            }
        </>
    )
}

export default SourceDataFormMessages;